/** ローカルの広告枠確認だけに使う。実広告・アクセス解析はプレビューモードで送信しない。 */
export const ADSENSE_PREVIEW =
	process.env.NEXT_PUBLIC_PREVIEW_MODE === "1" &&
	process.env.NEXT_PUBLIC_ADSENSE_PREVIEW === "1";

/** 設定済みの本番枠、または確認専用の枠名を返す。未設定・通常の開発表示では広告を出さない。 */
export function getAdsenseSlot(slot: string | undefined, previewSlot: string): string | undefined {
	if (ADSENSE_PREVIEW) return previewSlot;
	if (
		process.env.NODE_ENV !== "production" ||
		process.env.NEXT_PUBLIC_PREVIEW_MODE === "1" ||
		!process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_CLIENT?.trim()
	) return undefined;
	return slot?.trim() || undefined;
}
